import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Login.css';

const API_URL = 'https://trabajaconnosotros.roboticminds.ec/api';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Usar useCallback para evitar recrear la función en cada render
  const checkToken = useCallback(async (token) => {
    try {
      const response = await axios.get(`${API_URL}/usuario`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Si el token es válido, redirigir al panel
      if (response.status === 200) {
        navigate('/panel');
      }
    } catch (err) {
      // Si hay error, el token no es válido, eliminarlo
      console.log('Token inválido o expirado:', err.message);
      localStorage.removeItem('token');
    }
  }, [navigate]);

  // Verificar si ya hay un token válido al cargar
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      checkToken(token);
    }
  }, [checkToken]); // Agregamos checkToken como dependencia

  // Manejar cambios en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError(''); // Limpiar errores al escribir
  };

  // Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!formData.email || !formData.password) {
      setError('Por favor ingrese email y contraseña');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(`${API_URL}/login`, formData);
      
      // Guardar token en localStorage
      localStorage.setItem('token', response.data.token);
      
      // Redireccionar al panel
      navigate('/panel');
    } catch (err) {
      console.error('Error de login:', err);
      
      // Mostrar mensaje de error
      if (err.response?.status === 401) {
        setError('Credenciales incorrectas');
      } else {
        setError('Error al iniciar sesión. Intente nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <h1>Acceso al Panel</h1>
        <p>Ingrese sus credenciales para continuar</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;